export const getConfirmationTitle = (
  isVoid: boolean,
  editId?: number,
  hasSubmissions?: boolean,
): string => {
  if (hasSubmissions) {
    return 'Contract has submissions';
  }
  if (isVoid) {
    return 'Void contract';
  }
  return `Confirm ${editId ? 'changes' : 'new contract'}`;
};
